import axios from "axios";
import { apiEndpoint, apiEndpointFunction } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';

export const subCategoryGlobalFormService = {
  get,
  storeOrUpdate,
  destroy,
};

// List sub-categories, optionally scoped to a category (TAX-03).
function get(categoryId = null){
    return (
        axios
            .get(
                `${apiEndpoint.subCategoryGlobalForm}${categoryId ? `?category_global_form_id=${categoryId}` : ''}`,
                {
                    headers: authHeader(),
                }
            ).then(res => {
            if(res && res.status === 200){
                return res.data;
            }
        })
    );
}

function storeOrUpdate(data, id = null){
    return (id ? (
        axios
          .put(
              `${apiEndpointFunction.subCategoryGlobalForm(id)}`,
            data,
            {
              headers: authHeader(),
            }
          )
    ) : (
        axios
          .post(
            apiEndpoint.subCategoryGlobalForm,
            data,
            {
              headers: authHeader()
            }
          )
    )).then(res => {
        if(res && res.status === 200){
          return res.data;
        }
        return {};
    });
}

function destroy(id){
    return (
        axios
            .delete(
                `${apiEndpointFunction.subCategoryGlobalForm(id)}`,
                {
                    headers: authHeader(),
                }
            ).then(res => {
            if(res && res.status === 200){
                return res.data;
            }
        })
    );
}
